import React from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash.isequal';

import {
    requestMyTimesheetEntriesLoad,
    myTimesheetEntriesLoadCanceled
} from 'services/myTimesheetEntries/actions';
import { AppState } from 'services/types';
// @ts-ignore
import { selectMyTimesheetsLoadParams } from 'services/myTimesheetEntries/params';
import { createStructuredSelector } from 'reselect';

interface ConnectedProps {
    parameters: Record<string, any>;
}

interface DispatchProps {
    loadTimesheetEntries: Function;
    cancelLoadTimesheetEntries: Function;
}

type Props = ConnectedProps & DispatchProps;

export class MyTimesheetEntriesRequest extends React.Component<Props> {
    componentDidMount(): void {
        const { loadTimesheetEntries } = this.props;

        loadTimesheetEntries();
    }

    componentDidUpdate(prevProps: Props): void {
        const { parameters, loadTimesheetEntries } = this.props;

        if (!isEqual(prevProps.parameters, parameters)) {
            loadTimesheetEntries();
        }
    }

    componentWillUnmount(): void {
        const { cancelLoadTimesheetEntries } = this.props;

        cancelLoadTimesheetEntries();
    }

    render(): null {
        return null;
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    parameters: selectMyTimesheetsLoadParams
});

export default connect(
    mapStateToProps,
    {
        loadTimesheetEntries: requestMyTimesheetEntriesLoad,
        cancelLoadTimesheetEntries: myTimesheetEntriesLoadCanceled
    }
)(MyTimesheetEntriesRequest);
